import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

interface DividerProps {
  className?: string
  children?: ReactNode
}

export function Divider({ className, children }: DividerProps) {
  return (
    <div className={cn("flex items-center justify-center gap-2", className)}>
      <span className="h-px flex-1 bg-gradient-to-r from-transparent to-[var(--border-heavy)]" />
      {children ?? <span className="text-accent-dim">◆</span>}
      <span className="h-px flex-1 bg-gradient-to-r from-[var(--border-heavy)] to-transparent" />
    </div>
  )
}
